import "./style.css";
import { tns } from "@/node_modules/tiny-slider/src/tiny-slider";
import "@/node_modules/tiny-slider/dist/tiny-slider.css";

export default class ImagesGallery {
  static selector = ".images-gallery";

  constructor(block) {
    this.block = block;

    this.slides = this.block.querySelectorAll(".images-gallery__item");
    this.navContainer = this.block.querySelector(".carousel-dots");
    this.prevButton = this.block.querySelector(".carousel-arrows--prev");
    this.nextButton = this.block.querySelector(".carousel-arrows--next");
  }

  onReady() {
    // add dots based on number of items
    this.slides.forEach(() => {
      var node = document.createElement("button");
      node.classList.add("carousel-dots__dot");
      this.navContainer.appendChild(node);
    });

    this.dots = this.block.querySelectorAll(".carousel-dots__dot");
    if (this.dots.length > 0) {
      this.dots[0].classList.add("active");
    }
    
    this.slider = tns({
      container: "#gallery-slider",
      prevButton: this.prevButton,
      nextButton: this.nextButton,
      navContainer: this.navContainer,
      slideBy: 1,
      items: 1,
      gutter: 24,
      fixedWidth: 260,
      loop: false,
      mouseDrag: true,
      responsive: {
        765: {
          items: 3,
          gutter: 28,
        },
        1025: {
          fixedWidth: false,
        },
      },
    });
    this.handleListeners();
  }

  handleListeners = () => {
    this.slider.events.on("indexChanged", this.handleControls);
  };

  handleControls = (e) => {
    // prev button
    if (e.index === 0) {
      this.prevButton.classList.add("disabled");
    } else if (e.index > 0) {
      this.prevButton.classList.remove("disabled");
    }
    // next button
    if (e.index + e.items === e.slideCount) {
      this.nextButton.classList.add("disabled");
    } else {
      this.nextButton.classList.remove("disabled");
    }

    this.dots.forEach((dot, i) => {
      if (i === e.index) {
        dot.classList.add("active");
      } else {
        dot.classList.remove("active");
      }
    });
  };
}
